import styled, { keyframes } from 'styled-components';

interface Props {
  type: string,
  position: number,
}

const animation = (props: Props) => keyframes`
  0% {
    top : -30px;
    opacity: 0;
  }
  15% {
    top: 10px;
    opacity: 1;
  }
  85% {
    top: 10px;
    opacity: 1;
  }
  100% {
    top : -30px;
    opacity: 0;
  }
`;

const Wrapper = styled.div``;

const Box = styled.div`
  animation: ${animation} 5s ease-in-out;
  max-width: 500px;
  height: 50px;
  z-index: 1000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: -5rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 30px;
  border-radius: 4px;
  box-shadow: 1px 5px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0.5px;
  background-color: ${(props: Props) => props.type === 'info' ? '#00C851' : props.type === 'warning' ? '#ffbb33' : '#e95950'};

  @media only screen and (max-width: 767px) {
    width: 80%;
  }
`;

export {
  Wrapper,
  Box,
};
